import { useMutation } from "@tanstack/react-query";
import { updateBrandLanguage } from "../api/updateBrandLanguage";
import { UpdateBrandLanguage } from "../type";

type Params = {
  brandId: string;
  languageId: string;
  language: UpdateBrandLanguage;
};

export const useUpdateBrandLanguageMutation = () => {
  return useMutation({
    mutationFn: async ({ brandId, languageId, language }: Params) => {
      return await updateBrandLanguage(brandId, languageId, language);
    },
  });
};
